import { Module } from "@baseline/runtime/module";
import * as webpack from "@baseline/runtime/webpack/module";


export interface ComponentModule extends webpack.Module
{
    moduleType?: "react";
    // exports: Record<string, FC> & {
    //     moduleType?: "react";
    // };
}


export namespace ComponentModule
{
    export function isComponentModule(module: Module): module is ComponentModule;
    export function isComponentModule(module: ComponentModule): module is ComponentModule
    {
        return module?.moduleType == "react";
        // return module?.exports?.moduleType == "react";
    }
}
